import "./styles.sass";

import React, { FC, useEffect, useState } from "react";
import { IRouteData } from "../../router/RouterData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../..";
import { LogoutIcon } from "../../assets/icons";
import CustomLink from "./Link";

export interface IRenderItem {
  item: IRouteData;
}

const Sidebar: FC = () => {
  const { store } = useContext(Context);
  const [usePathname, setUsePathname] = useState<string>("");
  const location = useLocation();
  const [userRoutes, setUserRoutes] = useState([])

  const navigate = useNavigate();

  useEffect(() => {
    setUsePathname(location.pathname);
  }, [location]);

  useEffect(() => {
    if (store?.user?.role) {
      const newRoute = JSON.parse(JSON.stringify(store?.user?.role));
      setUserRoutes(newRoute)
    }
  }, [store.user])

  const RenderItem: any = (item: any) => {
    const data = item.item
    const length = Object.keys(data).length
    return (
      <>
        {length ? (
          <div>
            <div className={`item ${usePathname === data.path && "active"}`}>
              <div className="name">{data.title}</div>
            </div>
            {data.children && data.children.map((dataChild: any) => (
              <CustomLink
                to={`/admin/${data.path}/${dataChild.path}`}
                itemChild={dataChild}
                item={data}
                key={`admin-${data.path}-${dataChild.path}`}
              />
            ))}
          </div>
        ) : (
          <>
            {data.visible && (
              <Link
                to={`/admin/${data.path}`}
                className={`data ${usePathname === data.path && "active"}`}
              >
                <div className="icon-container">{data.icon}</div>
                <div className="name">{data.title}</div>
              </Link>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <div className={`sidebar`}>
      <div className="sidebar-container">
        <nav className="nav">
          {userRoutes.map((item, index) => (
            <RenderItem item={item} key={`sidebar-item-${index}`} />
          ))}
        </nav>
        <button
          className="logout"
          onClick={() => {
            store.logout().then(() => {
              navigate("/")
            });

          }}
        >
          <div className="icon">
            <LogoutIcon />
          </div>
          <div className="name">Logout</div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
